<template>
  <section class="mb-12 text-center">
    <h1
      class="display-3 font-weight-light mb-3"
      v-text="`${heading}`"
    />
  </section>
</template>

<script>
  export default {
    name: 'VComponent',

    props: {
      heading: {
        type: String,
        default: '',
      },
      link: {
        type: String,
        default: '',
      },
    },
  }
</script>
